import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { NonBlockingNotificationType, NotificationType } from 'src_server/trpc/types/accountModel/accountResponse';
import { AccountReviewNotification } from './AccountReviewNotification';
import { useCommon } from 'src/domains/common/Common';
import { NonBlockingNotificationsState } from 'src/domains/players/state/NonBlockingNotification.state';

interface BlockingNotificationsPropsType {
    nonBlockingNotificationType: NotificationType;
}

export const NonBlockingNotifications = observer(
    'NonBlockingNotifications',
    ({ nonBlockingNotificationType }: BlockingNotificationsPropsType): JSX.Element | null => {
        const common = useCommon();
        const nonBlockingNotificationsState = NonBlockingNotificationsState.get(common);

        switch (nonBlockingNotificationType) {
            case NonBlockingNotificationType.REVIEW_ACCOUNT:
                return (
                    <AccountReviewNotification onConfirm={nonBlockingNotificationsState.handleConfirmReviewAccount} />
                );
            default:
                return null;
        }
    }
);
